<template>
  <div class="menu-tile" @click.stop="$emit('click')">
    <div class="icon-circle">
      <icon class="icon" v-bind="iconProps" size="28px" variant="rounded" />
    </div>
    <div class="text ri-small-body margin-top-sm">{{ text }}</div>
  </div>
</template>

<script>
import BaseUI from '@riseupil/base-ui';

export default {
  name: 'MenuTile',
  components: {
    Icon: BaseUI.Icon,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    iconProps: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';
@import '~@riseupil/base-ui/src/scss/border-radius';
@import '~@riseupil/base-ui/src/scss/spacings';

$tile-size: 50px;

.menu-tile {
  display: flex;
  width: $tile-size;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  .text {
    text-align: center;
    color: $riseup_black;
    line-height: 14px;
  }

  .icon-circle {
    display: flex;
    align-items: center;
    justify-content: center;
    background: $riseup_white;
    border-radius: 30px;
    width: 100%;
    height: $tile-size;
  }
}
</style>
